(function () {
    'use strict';

    function init() {
        setupSwiper('.js-gallery', {
            containerSelector: '.js-gallery-container',
            jsSelector: '.js-gallery',
            swiperOptions: {
                slidesPerView: 1,
                spaceBetween: 0,
                on: {
                    slideChange: function () {
                        const current = this.realIndex + 1;
                        const currentCount = this.el.querySelector('.js-gallery-count-current');
                        currentCount.textContent = current;
                    }
                }
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();